module.exports = __webpack_public_path__ + "static/media/avator.371dac07.png";